import { FC } from "react"
import cx from "classnames"
import Button from "../Button"
import OutlineButton from "../OutlineButton"
import Modal, { ModalProps } from "../Modal"

type Props = {
  className?: string
  message: React.ReactNode
  onConfirm: () => void
} & ModalProps

const ConfirmModal: FC<Props> = ({
  className,
  message,
  open,
  onClose,
  onConfirm,
  ...rest
}: Props) => {
  const handleConfirm = () => {
    onConfirm()
    onClose && onClose()
  }
  return (
    <Modal
      title="Confirmation"
      open={open}
      onClose={onClose}
      className={cx("", className)}
      onSubmit={handleConfirm}
      actions={
        <div className="flex gap-4">
          <OutlineButton
            className={cx("text-black btn-sm !w-16", className)}
            type="button"
            onClick={onClose}
            {...rest}
          >
            No
          </OutlineButton>
          <Button type="submit" className="!w-16 btn-sm">
            Yes
          </Button>
        </div>
      }
      {...rest}
    >
      {message}
    </Modal>
  )
}

export default ConfirmModal
